/* @ngInject */

export default ($q, logger, quickToolDataFactory) => {
  /**
   * Generate PDF.
   *
   * @param {Object} [params]
   *
   * @returns {Array}
   */
  const getBase64FromImageUrl = (params) => {
    const deferred = $q.defer();
    logger.log('quickToolService', 'getBase64FromImageUrl', 'Resolving DataFactory');
    quickToolDataFactory.getBase64FromImageUrl(params).then((data) => {
      logger.log(`quickToolService | getBase64FromImageUrl | Resolved ${data} objects`);
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  return {
    getBase64FromImageUrl
  };
};
